import React, { useEffect, useState } from 'react';
import SnackBarCustom from '../../app/modules/Comun/SnackBars/SnackBarCustom';
import * as checkActions from './_redux/apiVersionActions';
import { useDispatch, shallowEqual, useSelector } from "react-redux";

export const VersionsCheck = () => {
    const dispatch = useDispatch();
    const [clienteDesactualizado, setClienteDesactualizado] = useState(false);
    const mensajeApiVersion = 'Estas usando una version anterior de la aplicación. Refrescar';
    const { apiVersion } = useSelector(
        (state) => ({ apiVersion: state.apiVersion }),
        shallowEqual
    );
    const {
        apiVersionState,
        listLoading,
        error
    } = apiVersion;

    useEffect(() => {
        //SE DISPARA DOS VECES
        //NO HAY POLQUE
        dispatch(checkActions.fetchApiVersion({}));
        const clientVersion = JSON.parse(localStorage.clientVersion || '{}');
        if (apiVersionState && !listLoading) {
            if (clientVersion !== apiVersionState) {
                localStorage.clientVersion = JSON.stringify(apiVersionState);
                setClienteDesactualizado(true);
            } else {
                setClienteDesactualizado(false);
            };
        };
    }, [apiVersionState, listLoading]);
    return (
        <>
            {clienteDesactualizado && <SnackBarCustom tipo="warning" mensaje={mensajeApiVersion} aceptar={() => window.location.reload()} />}
            {(error) && <SnackBarCustom tipo="error" mensaje={error} />}
        </>
    );
};
